<script>
export const pageName = 'inventory-motors-edit';
export const pageRoute = '/inventory/motors/{motorId}/edit';
export const title = 'Edit Motor(s)'
export const requireMembership = true;

import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { navigate } from '@trullock/page-manager'
import { commands } from '../../js/lib/functions.js';
import { showToast } from '../../js/utils/toast.js'
import TomSelect from 'tom-select'
import { listenToMotorsInventory } from '../../js/readModel.js';
import { getCurrentUserId } from '../../js/auth.js';

export default {
	data() {
		return { 
			motor: null,
			motorId: null,
			manufacturer: null,
			designation: null,
			name: null,
			classification: 'A',
			totalImpulse: 0,
			delay: '0',
			diameter: null,
			length: null,
			type: 'su',
			casing: null,
			propWeight: null,
			propType: null,
			quantity: 1,
			notes: null
		}
	},

	methods: {
		beforeHide() {
			return this.isDirty ? 'Are you sure you want to abandon these changes?' : null
		},
		async boot(opts) {
			
			await listenToMotorsInventory(getCurrentUserId(), 'stock', inventory => {
				this.motor = inventory.findMotor(opts.motorId);
			});
		},
		async show(opts) {
			commands.warmUp();

			this.isDirty = false;

			this.motorId = this.motor.motorId;
			this.manufacturer = this.motor.manufacturer;
			this.designation = this.motor.designation;
			this.name = this.motor.name;
			this.classification = this.motor.classification;
			this.totalImpulse = this.motor.totalImpulse;
			this.delay = this.motor.delay;
			this.diameter = this.motor.diameter;
			this.length = this.motor.length;
			this.type = this.motor.type;
			this.casing = this.motor.casing;
			this.propWeight = this.motor.propWeight;
			this.propType = this.motor.propType;
			this.quantity = this.motor.quantity;
			this.notes = this.motor.notes;
		},
		changed() {
			this.isDirty = true;
		},
		async submit () {
			showLoading();

			let result = await commands.inventory.motors.update({
				motorId: this.motor.motorId,
				quantity: this.quantity,
				notes: this.notes
			});

			if(!result.success)
			{
				showToast({ message: 'Error updating motor', style: 'bg-danger'})
				hideLoading();
				return;
			}

			this.isDirty = false;

			navigate(`/inventory/motors`)

			showToast({
				message: 'Motor(s) saved',
				style: 'bg-success'
			})

			hideLoading();
		}
	}
}

</script>
<template>
	<div class="container py-5">
		<div class="row justify-content-center">
			<div class="col-12 col-md-8 col-xl-6 my-5">
				<h1 class="display-4 text-center mb-3">Edit Motors</h1>
				<p class="text-muted text-center mb-5">Edit motors in your inventory.</p>
					
				<form @submit.prevent="submit" @change="changed">
					<div class="row">
						<div class="col">
							<div class="form-group">
								<label class="form-label">
									Manufacturer
								</label>
								<input type="text" class="form-control" v-model="manufacturer" readonly required placeholder="e.g. Estes">
								<span class="invalid-feedback mt-2"></span>
							</div>
						</div>
						<div class="col">
							<div class="form-group">
								<label class="form-label">
									Name
								</label>
								<input type="text" class="form-control" v-model="name" readonly required placeholder="e.g. I59">
								<span class="invalid-feedback mt-2"></span>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<div class="form-group">
								<label class="form-label">
									Impulse Class
								</label>
								<select class="form-control" v-model="classification" disabled>
									<option v-for="c of [...Array(15).keys()].map(i => String.fromCharCode(65 + i))" :value="c">{{ c }}</option>
								</select>
								<span class="invalid-feedback mt-2"></span>
							</div>
						</div>
						<div class="col">
							<div class="form-group">
								<label class="form-label">
									Designation
								</label>
								<input type="text" class="form-control" v-model="designation" placeholder="e.g. I59WN" readonly required>
								<span class="invalid-feedback mt-2"></span>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<div class="form-group">
								<label class="form-label">
									Total impulse
								</label>
								<div class="input-group has-validation">
									<input type="number" autocomplete="off" min="0" max="999999" step="0.01" v-model="totalImpulse" class="form-control" readonly required/>
									<div class="input-group-append">
										<div class="input-group-text">
											Ns
										</div>
									</div>
									<span class="invalid-feedback"></span>
								</div>
							</div>
						</div>
						<div class="col">
							<div class="form-group">
								<label class="form-label">
									Delay
								</label>
								<div class="input-group has-validation">
									<input type="text" autocomplete="off" pattern="([0-9]+)|(P)" v-model="delay" class="form-control" readonly required placeholder="e.g. 6" />
									<div class="input-group-append">
										<div class="input-group-text">
											s
										</div>
									</div>
									<span class="invalid-feedback"></span>
								</div>
									<p class="form-text text-muted small mb-0">Either an integer or P for plugged.</p>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<div class="form-group">
								<label class="form-label">
									Diameter
								</label>
								<div class="input-group has-validation">
									<input type="number" min="1" max="999" step="1" autocomplete="off" v-model="diameter" class="form-control" readonly required placeholder="e.g. 24" />
									<div class="input-group-append">
										<div class="input-group-text">
											mm
										</div>
									</div>
									<span class="invalid-feedback"></span>
								</div>
							</div>
						</div>
						<div class="col">
							<div class="form-group">
								<label class="form-label">
									Length
								</label>
								<div class="input-group has-validation">
									<input type="number" min="1" max="9999" step="0.1" autocomplete="off" v-model="length" class="form-control" readonly required placeholder="e.g. 70" />
									<div class="input-group-append">
										<div class="input-group-text">
											mm
										</div>
									</div>
									<span class="invalid-feedback"></span>
								</div>
							</div>
						</div>
					</div>
					readonly
					<div class="row">
						<div class="col">
							<div class="form-group">
								<label class="form-label">
									Type
								</label>
								<select class="form-control" v-model="type" disabled>
									<option value="su">Single use</option>
									<option value="reload">Reload</option>
								</select>
								<span class="invalid-feedback mt-2"></span>
							</div>
						</div>
						<div class="col">
							<div class="form-group">
								<label class="form-label">
									Case
								</label>
								<input type="text" class="form-control" :disabled="type=='su'" v-model="casing" :required="type!='su'" readonly placeholder="e.g. Pro29-2G">
								<span class="invalid-feedback mt-2"></span>
							</div>
						</div>
					</div>

					
					<div class="row">
						<div class="col">
							<div class="form-group">
								<label class="form-label">
									Propellant weight
								</label>
								<div class="input-group has-validation">
									<input type="number" min="0.01" max="99999" step="0.01" autocomplete="off" v-model="propWeight" class="form-control" readonly required placeholder="e.g. 5" />
									<div class="input-group-append">
										<div class="input-group-text">
											g
										</div>
									</div>
									<span class="invalid-feedback"></span>
								</div>
							</div>
						</div>
						<div class="col">
							<div class="form-group">
								<label class="form-label">
									Propellant type
								</label>
								<input type="text" autocomplete="off" v-model="propType" class="form-control" readonly required placeholder="e.g. Black Powder" />
								<span class="invalid-feedback"></span>
							</div>
						</div>
					</div>
					<hr class="my-5" />
					<div class="form-group">
						<label class="form-label">
							Quantity
						</label>
						<input type="number" min="0" step="1" max="9999" class="form-control" v-model="quantity" placeholder="e.g. 10">
						<span class="invalid-feedback mt-2"></span>
					</div>
					<div class="form-group">
						<label class="form-label mb-1">Notes</label>
						<textarea class="form-control" v-model="notes" rows="4"></textarea>
					</div>
					<button class="btn w-100 btn-primary">Update motor <span class="fe fe-check-circle"></span></button>
				</form>
			</div>
		</div>
    </div>
</template>
